module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"invite-text":"Capitalist приглашает <br /> всех желающих <br /> поучаствовать в нашей <br /> реферальной программе."},"en":{"invite-text":"Capitalist invites everyone <br/> to participate in our referral program.","Реферальная программа":"Referral program","Узнать больше":"Read more"}}')
  delete Component.options._Ctor
}
